import { Controller } from "@hotwired/stimulus"
import { search, quote } from "../gate"

export default class extends Controller {
  static targets = ["name", "symbol", "currency", "results"]

  search() {
    const term = this.nameTarget.value.trim()
    clearTimeout(this.timer)
    if (term.length < 2) {
      this.close()
      return
    }

    this.timer = setTimeout(async () => {
      const securities = await search(term)
      if (this.nameTarget.value.trim() !== term) return

      this.resultsTarget.replaceChildren(...securities.map((security) => this.option(security)))
    }, 250)
  }

  navigate(event) {
    if (event.key === "Escape") {
      this.close()
    } else if (event.key === "Enter" && this.resultsTarget.firstElementChild) {
      event.preventDefault()
      this.resultsTarget.firstElementChild.dispatchEvent(new MouseEvent("mousedown"))
    }
  }

  close() {
    clearTimeout(this.timer)
    this.resultsTarget.replaceChildren()
  }

  option(security) {
    const button = document.createElement("button")
    button.type = "button"
    button.className = "suggestion-search__option"
    button.setAttribute("role", "option")

    const symbol = document.createElement("span")
    symbol.className = "suggestion-search__symbol"
    symbol.textContent = security.symbol
    const name = document.createElement("span")
    name.className = "suggestion-search__name"
    name.textContent = [security.name, security.exchange].filter(Boolean).join(" · ")

    button.append(symbol, name)
    button.addEventListener("mousedown", (event) => {
      event.preventDefault()
      this.pick(security)
    })
    return button
  }

  async pick(security) {
    this.nameTarget.value = security.name
    this.symbolTarget.value = security.symbol
    this.currencyTarget.value = ""
    this.close()
    this.currencyTarget.focus()

    const data = await quote(security.symbol).catch(() => null)
    if (data?.currency && this.symbolTarget.value === security.symbol && !this.currencyTarget.value) {
      this.currencyTarget.value = data.currency
    }
  }
}
